/**
 * FOAM CANNON PRO BUNDLE SYSTEM v2
 * cleandetail.nl
 * 
 * Adds only Foam Cannon Pro to cart with adapter info in properties
 * - Cart shows: 1 item with adapter name
 * - Checkout shows: 1 item
 * - Order properties contain adapter SKU for packing slip
 */
(function() {
  'use strict';

  const CONFIG = {
    mainProduct: 'foam-cannon-pro',
    adapterProduct: 'foam-cannon-adapter-bundel'
  };

  const productHandle = document.body.getAttribute('data-product-handle');
  if (!productHandle || productHandle.toLowerCase() !== CONFIG.mainProduct) return;

  console.log('[Bundle] Initializing for Foam Cannon Pro');

  let mainVariants = [];
  let adapterVariants = [];
  let currentMain = null;
  let currentAdapter = null;
  let isProcessing = false;

  async function init() {
    try {
      const [mainRes, adapterRes] = await Promise.all([
        fetch('/products/' + CONFIG.mainProduct + '.js'),
        fetch('/products/' + CONFIG.adapterProduct + '.js')
      ]);
      
      const mainProduct = await mainRes.json();
      const adapterProduct = await adapterRes.json();
      
      mainVariants = mainProduct.variants;
      adapterVariants = adapterProduct.variants;

      // Get initial selection
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      currentMain = variantId 
        ? mainVariants.find(v => v.id == variantId)
        : mainVariants.find(v => v.available) || mainVariants[0];

      if (currentMain) {
        currentAdapter = adapterVariants.find(v => v.option1 === currentMain.option1);
      }

      setupListeners();
      console.log('[Bundle] Ready. Main:', currentMain?.title, 'Adapter:', currentAdapter?.title);
    } catch (e) {
      console.error('[Bundle] Init error:', e);
    }
  }

  function setupListeners() {
    // Dropdown change
    document.addEventListener('click', function(e) {
      const opt = e.target.closest('.combo-box__option-item');
      if (!opt) return;
      
      const name = opt.textContent.trim();
      currentMain = mainVariants.find(v => v.option1 === name);
      currentAdapter = adapterVariants.find(v => v.option1 === name);
      
      document.querySelectorAll('input[name="id"]').forEach(i => {
        if (currentMain) i.value = currentMain.id;
      });
      
      console.log('[Bundle] Selected:', name);
    });

    // Add to cart - capture phase
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('#AddToCart, [data-product-add-to-cart-button]');
      if (btn && !isProcessing) {
        addBundle(e, btn);
      }
    }, true);
  }

  async function addBundle(e, btn) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (!currentMain || !currentAdapter) {
      alert('Selecteer een adapter');
      return;
    }

    if (!currentMain.available) {
      console.log('[Bundle] Main product not available');
      return;
    }

    isProcessing = true;
    btn.disabled = true;

    const qty = parseInt(document.querySelector('input[name="quantity"]')?.value) || 1;
    const adapterName = currentAdapter.option1 || currentAdapter.title;
    const adapterSKU = currentAdapter.sku || '';
    const adapterBarcode = currentAdapter.barcode || '';

    console.log('[Bundle] Adding to cart...');
    console.log('[Bundle] Main ID:', currentMain.id, 'SKU:', currentMain.sku);
    console.log('[Bundle] Adapter SKU:', adapterSKU, 'Barcode:', adapterBarcode);

    try {
      // Add ONLY the main product with adapter info in properties
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: currentMain.id,
          quantity: qty,
          properties: {
            '_Adapter': adapterName,
            '_Adapter_SKU': adapterSKU,
            '_Adapter_Barcode': adapterBarcode
          }
        })
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Kon niet toevoegen');
      }

      console.log('[Bundle] Added successfully!');

      // Update cart count
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('cart-count, .header__cart-count, .bubble-count').forEach(el => {
        el.textContent = cart.item_count;
      });

      // Refresh cart drawer
      const sectionsRes = await fetch('/?sections=mini-cart');
      const sections = await sectionsRes.json();
      if (sections['mini-cart']) {
        const miniCart = document.querySelector('#mini-cart');
        if (miniCart) {
          const temp = document.createElement('div');
          temp.innerHTML = sections['mini-cart'];
          const newContent = temp.querySelector('#mini-cart');
          if (newContent) miniCart.innerHTML = newContent.innerHTML;
        }
      }

      // Open cart drawer
      const miniCart = document.querySelector('#mini-cart');
      if (miniCart) {
        miniCart.setAttribute('open', '');
        setTimeout(() => {
          if (!miniCart.hasAttribute('open')) {
            document.querySelector('[aria-controls="mini-cart"]')?.click();
          }
        }, 50);
      }

    } catch (err) {
      console.error('[Bundle] Error:', err);
      alert('Fout bij toevoegen: ' + err.message);
    }

    btn.disabled = false;
    isProcessing = false;
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
